import gsap from 'gsap';

export const scrollPageTo = (scrollTop = 0, duration = 500) => {
  const scrollElement =
    window.document.scrollingElement || window.document.body || window.document.documentElement;

  gsap.to(scrollElement, {
    scrollTop,
    duration: duration / 1000, // GSAP використовує секунди
    ease: 'power2.inOut',
  });
};

export const listenerFirstInteraction = (callBack) => {
  const opts = { passive: true, once: true, capture: true };
  // Фолбек: якщо взаємодії ще не було, відкриємо при першому ж кроці
  const onFirst = () => {
    callBack();
    ['pointerdown', 'keydown', 'touchstart', 'scroll', 'mousemove'].forEach((e) =>
      window.removeEventListener(e, onFirst, opts)
    );
  };

  ['pointerdown', 'keydown', 'touchstart', 'scroll', 'mousemove'].forEach((e) =>
    window.addEventListener(e, onFirst, opts)
  );
};

// Якщо елемент фіксовани потрібно додавати компенсацію скрола.
// padding-right: var(--scrollbar-compensation, 0);
export const hideBodyScroll = () => {
  // if (CSS.supports('scrollbar-gutter', 'stable')) {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth === 0) return;

  document.body.style.overflow = 'hidden';
  // document.documentElement.style.setProperty('scrollbar-gutter', 'stable');
  // }
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  document.documentElement.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
};

export const showBodyScroll = () => {
  // if (CSS.supports('scrollbar-gutter', 'stable')) {
  document.body.style.removeProperty('overflow');
  // document.documentElement.style.removeProperty('scrollbar-gutter');
  document.body.style.paddingRight = '';
  document.documentElement.style.removeProperty('--scrollbar-compensation');
  // }
};
